import { Switch } from '@atom/mui';

import MapDrawerLayerIcon from './MapDrawerLayerIcon';

import classes from './mapDrawerLayers.module.css';

interface Props {
  onUpdate: (boolean) => Promise<any>;
  toggled: boolean;
}

const MapDrawerLayersUsersSection = ({ onUpdate, toggled }: Props) => {
  return (
    <div className={classes.sectionContainer}>
      <div className={classes.sectionHeaderContainer}>
        <Switch
          label={
            <div className={classes.toggleLabel}>
              <div className={classes.sectionHeaderIcon}>
                <MapDrawerLayerIcon name="account_circle" />
              </div>
              <div>Team</div>
            </div>
          }
          checked={toggled}
          onChange={() => {
            onUpdate(!toggled);
          }}
        />
      </div>
    </div>
  );
};

export default MapDrawerLayersUsersSection;
